import React from 'react';
import { Box } from '@mui/material';
import { Route, Routes } from 'react-router-dom';

import SignUpPage from './pages/SignUpPage';
import SignUpBarber from './pages/ShopPages/SignUpShop';
import UserDashboard from './pages/UserPages/UserDashboard';
import Barbers from './pages/UserPages/Barbers';
import ProtectedRouteUser from './routes/ProtectedRouteUser';
import SignUpUser from './pages/UserPages/SignUpUser';
import BarberBookingPage from './pages/UserPages/BarberBookingPage';
import WalkInPage from './pages/UserPages/Walkinpage';
import ShopSetupPage from './pages/ShopPages/ShopSetupPage';
import ShopDashboard from './pages/ShopPages/ShopDashboard';
import BarberDashboard from './pages/BarberPages/BarberDashboard';
import JoinShopPage from './pages/BarberPages/JoinShopPage';
import RoleSelectPage from './pages/RoleSelectPage';
import UserBookings from './pages/UserPages/UserBookings';
import QueueTicket from './pages/UserPages/QueueTicket';
import MyQueue from './pages/UserPages/MyQueue';
import UserProfile from './pages/UserPages/UserProfilePage';
import EditBarberPage from './pages/BarberPages/EditBarberPage';
import BarberStats from './pages/BarberPages/BarberStats';
import AdminPage from './pages/Admin/AdminPahe';
import Landing from './pages/Landing/Landing'
function App() {

  return (
    <Routes>

      {/* ── Landing ── */}
      <Route path="/" element={<Landing />} />

      {/* ── Role ── */}
      <Route path="/role" element={<RoleSelectPage />} />

      {/* ── Auth ── */}
      <Route path="/signin" element={<SignUpPage />} />
      <Route path="/signup/barber" element={<SignUpBarber />} />
      <Route path="/signup/user" element={<SignUpUser />} />
      <Route path="/join" element={<JoinShopPage />} />
      <Route path="/barber/setup" element={<ShopSetupPage />} />

      {/* ── Public booking ── */}
      <Route path="/shop/:shopId/barber/:barberId/book" element={<BarberBookingPage />} />
      <Route path="/walkin/:shopId" element={<WalkInPage />} />

      {/* ── Shop owner dashboard ── */}
      <Route path="/user/:shopId/dashboard" element={<ShopDashboard />} />
      <Route path="/queue/:shopId/:bookingId" element={<QueueTicket />} />
      <Route path="/my-queue" element={<MyQueue />} />

      {/* ── Barber dashboard ── */}
      <Route path="/barber/:shopId/:barberId/dashboard" element={<BarberDashboard />} />
      <Route path="/barber/:shopId/:barberId/edit"  element={<EditBarberPage />} />
      <Route path="/barber/:shopId/:barberId/stats" element={<BarberStats />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/user/profile" element={
        <ProtectedRouteUser><UserProfile /></ProtectedRouteUser>
      } />

      {/* ── Customer routes (protected) ── */}
      <Route path="/user">
        <Route
          path="dashboard"
          element={
            <ProtectedRouteUser>
              <UserDashboard />
            </ProtectedRouteUser>
          }
        />
        <Route
          path=":shopId/barbers"
          element={
            <ProtectedRouteUser>
              <Barbers />
            </ProtectedRouteUser>
          }
        />
        <Route
          path="bookings"
          element={
            <ProtectedRouteUser>
              <UserBookings />
            </ProtectedRouteUser>
          }
        />
      </Route>

    </Routes>
  );
}

export default App;